/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { WorkApiService } from './services/work-api.service';
import { WorkEnvironmentService } from './services/work-environment.service';
import { WorkMailSenderV2Service } from './services/work-mail-sender-v-2.service';
import { WorkAxovaNasSyncV2Service } from './services/work-axova-nas-sync-v-2.service';
import { WorkTenantsProjectLinksV2Service } from './services/work-tenants-project-links-v-2.service';
import { WorkSelfserviceExternalProjectReferencesV2Service } from './services/work-selfservice-external-project-references-v-2.service';
import { WorkTenantsTaskLinksV2Service } from './services/work-tenants-task-links-v-2.service';
import { WorkTenantsTaskChangelogsV2Service } from './services/work-tenants-task-changelogs-v-2.service';
import { WorkTenantsDocumentLinksService } from './services/work-tenants-document-links.service';
import { WorkTenantsApiKeysV2Service } from './services/work-tenants-api-keys-v-2.service';
import { WorkTenantsV2Service } from './services/work-tenants-v-2.service';
import { WorkTenantsToTenantsV2Service } from './services/work-tenants-to-tenants-v-2.service';
import { WorkDocumentsService } from './services/work-documents.service';
import { WorkDocumentsV2Service } from './services/work-documents-v-2.service';
import { WorkElektroDrittkontrolleV2Service } from './services/work-elektro-drittkontrolle-v-2.service';
import { WorkGerustbauV2Service } from './services/work-gerustbau-v-2.service';
import { WorkMontageplanV2Service } from './services/work-montageplan-v-2.service';
import { WorkProjectsService } from './services/work-projects.service';
import { WorkProjectsV2Service } from './services/work-projects-v-2.service';
import { WorkAuthenticationService } from './services/work-authentication.service';
import { WorkAuthenticationV2Service } from './services/work-authentication-v-2.service';
import { WorkContactsService } from './services/work-contacts.service';
import { WorkContactsV2Service } from './services/work-contacts-v-2.service';
import { WorkContactsFinanceV2Service } from './services/work-contacts-finance-v-2.service';
import { WorkReservationsService } from './services/work-reservations.service';
import { WorkReservationsV2Service } from './services/work-reservations-v-2.service';
import { WorkGoogleCalendarApiService } from './services/work-google-calendar-api.service';
import { WorkUsersService } from './services/work-users.service';
import { WorkUsersV2Service } from './services/work-users-v-2.service';
import { WorkUsersMeV2Service } from './services/work-users-me-v-2.service';
import { WorkNotificationsV2Service } from './services/work-notifications-v-2.service';
import { WorkPhonesV2Service } from './services/work-phones-v-2.service';
import { WorkTimerecordBalancesV2Service } from './services/work-timerecord-balances-v-2.service';
import { WorkUseremploymentsV2Service } from './services/work-useremployments-v-2.service';
import { WorkSearchService } from './services/work-search.service';
import { WorkSearchV2Service } from './services/work-search-v-2.service';
import { WorkCalculationitemsGroupsV2Service } from './services/work-calculationitems-groups-v-2.service';
import { WorkCalculationitemsV2Service } from './services/work-calculationitems-v-2.service';
import { WorkStandardtasksV2Service } from './services/work-standardtasks-v-2.service';
import { WorkCalculationsV2Service } from './services/work-calculations-v-2.service';
import { WorkCalculationTemplatesV2Service } from './services/work-calculation-templates-v-2.service';
import { WorkPricesV2Service } from './services/work-prices-v-2.service';
import { WorkPriceTiersV2Service } from './services/work-price-tiers-v-2.service';
import { WorkBuildingservicesV2Service } from './services/work-buildingservices-v-2.service';
import { WorkReportsV2Service } from './services/work-reports-v-2.service';
import { WorkAccountingV2Service } from './services/work-accounting-v-2.service';
import { WorkProjectCostsV2Service } from './services/work-project-costs-v-2.service';
import { WorkConnectorsV2Service } from './services/work-connectors-v-2.service';
import { WorkAbsencesService } from './services/work-absences.service';
import { WorkAbsencesV2Service } from './services/work-absences-v-2.service';
import { WorkTasksV2Service } from './services/work-tasks-v-2.service';
import { WorkTaskChangeRequestsV2Service } from './services/work-task-change-requests-v-2.service';
import { WorkContactPersonsV2Service } from './services/work-contact-persons-v-2.service';
import { WorkDocumentsGeneratorService } from './services/work-documents-generator.service';
import { WorkDocumentsGeneratorV2Service } from './services/work-documents-generator-v-2.service';
import { WorkDocumentsGeneratorV3Service } from './services/work-documents-generator-v-3.service';
import { WorkHelpersService } from './services/work-helpers.service';
import { WorkDebtorsV2Service } from './services/work-debtors-v-2.service';
import { WorkDebtorsOverviewV2Service } from './services/work-debtors-overview-v-2.service';
import { WorkDebtorsCamtImportV2Service } from './services/work-debtors-camt-import-v-2.service';
import { WorkParashiftV2Service } from './services/work-parashift-v-2.service';
import { WorkEquipmentsV2Service } from './services/work-equipments-v-2.service';
import { WorkInteractionsV2Service } from './services/work-interactions-v-2.service';
import { WorkTicketsV2Service } from './services/work-tickets-v-2.service';
import { WorkTicketCategoriesV2Service } from './services/work-ticket-categories-v-2.service';
import { WorkLocationsService } from './services/work-locations.service';
import { WorkLocationsV2Service } from './services/work-locations-v-2.service';
import { WorkMailsV2Service } from './services/work-mails-v-2.service';
import { WorkItemsService } from './services/work-items.service';
import { WorkItemsV2Service } from './services/work-items-v-2.service';
import { WorkMessagingV2Service } from './services/work-messaging-v-2.service';
import { WorkDocumenttypesV2Service } from './services/work-documenttypes-v-2.service';
import { WorkProjectrevenuesService } from './services/work-projectrevenues.service';
import { WorkProjectrevenuesV2Service } from './services/work-projectrevenues-v-2.service';
import { WorkStandardtaskgroupsV2Service } from './services/work-standardtaskgroups-v-2.service';
import { WorkTimerecordHolidaysV2Service } from './services/work-timerecord-holidays-v-2.service';
import { WorkStocklocationsV2Service } from './services/work-stocklocations-v-2.service';
import { WorkProjectCheckRulesV2Service } from './services/work-project-check-rules-v-2.service';
import { WorkProjectChecksV2Service } from './services/work-project-checks-v-2.service';
import { WorkProjectDurationOverrunV2Service } from './services/work-project-duration-overrun-v-2.service';
import { WorkDocumentTemplatesV2Service } from './services/work-document-templates-v-2.service';
import { WorkTimerecorddetailsService } from './services/work-timerecorddetails.service';
import { WorkTimerecorddetailsV2Service } from './services/work-timerecorddetails-v-2.service';
import { WorkTimeBlockTemplatesV2Service } from './services/work-time-block-templates-v-2.service';
import { WorkChatsV2Service } from './services/work-chats-v-2.service';
import { WorkOnetimepasswordsV2Service } from './services/work-onetimepasswords-v-2.service';
import { WorkActivityTypesV2Service } from './services/work-activity-types-v-2.service';
import { WorkAddressService } from './services/work-address.service';
import { WorkAdminMaintenanceService } from './services/work-admin-maintenance.service';
import { WorkAdminDataQualityService } from './services/work-admin-data-quality.service';
import { WorkAdminMontageplanService } from './services/work-admin-montageplan.service';
import { WorkAdminDocumentIndexService } from './services/work-admin-document-index.service';
import { WorkAdminExternalProjectManagersService } from './services/work-admin-external-project-managers.service';
import { WorkAgentsV2Service } from './services/work-agents-v-2.service';
import { WorkAppDevicesService } from './services/work-app-devices.service';
import { WorkAppDevicesV2Service } from './services/work-app-devices-v-2.service';
import { WorkPushNotificationTokensService } from './services/work-push-notification-tokens.service';
import { WorkPushNotificationTokensV2Service } from './services/work-push-notification-tokens-v-2.service';
import { WorkArchiveboxesV2Service } from './services/work-archiveboxes-v-2.service';
import { WorkAudiencesV2Service } from './services/work-audiences-v-2.service';
import { WorkAuthenticatorsV2Service } from './services/work-authenticators-v-2.service';
import { WorkBudgetControllingV2Service } from './services/work-budget-controlling-v-2.service';
import { WorkBusinessdivisionsV2Service } from './services/work-businessdivisions-v-2.service';
import { WorkBusinessUnitsV2Service } from './services/work-business-units-v-2.service';
import { WorkCategoriesService } from './services/work-categories.service';
import { WorkCategoriesV2Service } from './services/work-categories-v-2.service';
import { WorkCommentsService } from './services/work-comments.service';
import { WorkNewsService } from './services/work-news.service';
import { WorkNewsV2Service } from './services/work-news-v-2.service';
import { WorkContainersV2Service } from './services/work-containers-v-2.service';
import { WorkContainertypesV2Service } from './services/work-containertypes-v-2.service';
import { WorkDocumentsubtypesService } from './services/work-documentsubtypes.service';
import { WorkDocumentsubtypesV2Service } from './services/work-documentsubtypes-v-2.service';
import { WorkElectricalMeasurementsService } from './services/work-electrical-measurements.service';
import { WorkElectricalmeasurementV2Service } from './services/work-electricalmeasurement-v-2.service';
import { WorkElectricalmeasurementtypesV2Service } from './services/work-electricalmeasurementtypes-v-2.service';
import { WorkEquipmentintervalsV2Service } from './services/work-equipmentintervals-v-2.service';
import { WorkEquipmentlogsV2Service } from './services/work-equipmentlogs-v-2.service';
import { WorkEquipmentlogtypesV2Service } from './services/work-equipmentlogtypes-v-2.service';
import { WorkEquipmenttypesV2Service } from './services/work-equipmenttypes-v-2.service';
import { WorkEventInvitationsService } from './services/work-event-invitations.service';
import { WorkEventInvitationsV2Service } from './services/work-event-invitations-v-2.service';
import { WorkEventInvitationtypesService } from './services/work-event-invitationtypes.service';
import { WorkEventRegistrationOptionsService } from './services/work-event-registration-options.service';
import { WorkEventsService } from './services/work-events.service';
import { WorkEventsV2Service } from './services/work-events-v-2.service';
import { WorkEventTypesService } from './services/work-event-types.service';
import { WorkFilesService } from './services/work-files.service';
import { WorkLoggingService } from './services/work-logging.service';
import { WorkItemGroupsService } from './services/work-item-groups.service';
import { WorkItemCatalogsV2Service } from './services/work-item-catalogs-v-2.service';
import { WorkVouchersV2Service } from './services/work-vouchers-v-2.service';
import { WorkAiServicesV2Service } from './services/work-ai-services-v-2.service';
import { WorkCronjobRunsV2Service } from './services/work-cronjob-runs-v-2.service';
import { WorkLeadCategoriesV2Service } from './services/work-lead-categories-v-2.service';
import { WorkLeadSubCategoriesV2Service } from './services/work-lead-sub-categories-v-2.service';
import { WorkLoxoneV2Service } from './services/work-loxone-v-2.service';
import { WorkMailtypesV2Service } from './services/work-mailtypes-v-2.service';
import { WorkMeetingAgendaItemsV2Service } from './services/work-meeting-agenda-items-v-2.service';
import { WorkMeetingDecisionsV2Service } from './services/work-meeting-decisions-v-2.service';
import { WorkMeetingParticipantsV2Service } from './services/work-meeting-participants-v-2.service';
import { WorkMeetingsV2Service } from './services/work-meetings-v-2.service';
import { WorkProspectsV2Service } from './services/work-prospects-v-2.service';
import { WorkMeetingTypesV2Service } from './services/work-meeting-types-v-2.service';
import { WorkMeetingTemplateAgendaItemsV2Service } from './services/work-meeting-template-agenda-items-v-2.service';
import { WorkMeetingTemplateParticipantsV2Service } from './services/work-meeting-template-participants-v-2.service';
import { WorkMessagingTemplatesV2Service } from './services/work-messaging-templates-v-2.service';
import { WorkProjectdossierTemplatesV2Service } from './services/work-projectdossier-templates-v-2.service';
import { WorkProjectdossiersV2Service } from './services/work-projectdossiers-v-2.service';
import { WorkProjectSharesV2Service } from './services/work-project-shares-v-2.service';
import { WorkProjectSharesPublicV2Service } from './services/work-project-shares-public-v-2.service';
import { WorkMyService } from './services/work-my.service';
import { WorkUsertrainingsV2Service } from './services/work-usertrainings-v-2.service';
import { WorkOrdercartsV2Service } from './services/work-ordercarts-v-2.service';
import { WorkOrdersV2Service } from './services/work-orders-v-2.service';
import { WorkOutcometypesV2Service } from './services/work-outcometypes-v-2.service';
import { WorkPermissionsV2Service } from './services/work-permissions-v-2.service';
import { WorkPersonnelFilesV2Service } from './services/work-personnel-files-v-2.service';
import { WorkPersonnelFileCategoriesV2Service } from './services/work-personnel-file-categories-v-2.service';
import { WorkPhonetypesV2Service } from './services/work-phonetypes-v-2.service';
import { WorkPowermembershipsV2Service } from './services/work-powermemberships-v-2.service';
import { WorkProductgroupsV2Service } from './services/work-productgroups-v-2.service';
import { WorkRealEstateTypesV2Service } from './services/work-real-estate-types-v-2.service';
import { WorkReasontypesV2Service } from './services/work-reasontypes-v-2.service';
import { WorkReferralsV2Service } from './services/work-referrals-v-2.service';
import { WorkReservationteamsV2Service } from './services/work-reservationteams-v-2.service';
import { WorkReservationtypesService } from './services/work-reservationtypes.service';
import { WorkReservationtypesV2Service } from './services/work-reservationtypes-v-2.service';
import { WorkRoletypesService } from './services/work-roletypes.service';
import { WorkRoletypesV2Service } from './services/work-roletypes-v-2.service';
import { WorkScreencomponentsV2Service } from './services/work-screencomponents-v-2.service';
import { WorkScreendevicesV2Service } from './services/work-screendevices-v-2.service';
import { WorkScreenslidesV2Service } from './services/work-screenslides-v-2.service';
import { WorkSelfserviceGenericService } from './services/work-selfservice-generic.service';
import { WorkSelfserviceItemsService } from './services/work-selfservice-items.service';
import { WorkSelfserviceProjectsService } from './services/work-selfservice-projects.service';
import { WorkSelfserviceCalculationitemsService } from './services/work-selfservice-calculationitems.service';
import { WorkSelfserviceProjectHouseSidesService } from './services/work-selfservice-project-house-sides.service';
import { WorkSelfserviceContactsService } from './services/work-selfservice-contacts.service';
import { WorkSelfserviceDocumentsService } from './services/work-selfservice-documents.service';
import { WorkSelfserviceRevenueRebateService } from './services/work-selfservice-revenue-rebate.service';
import { WorkSelfserviceRealEstateTypesService } from './services/work-selfservice-real-estate-types.service';
import { WorkSelfserviceTaskChangeRequestsService } from './services/work-selfservice-task-change-requests.service';
import { WorkSelfserviceProjectChecksService } from './services/work-selfservice-project-checks.service';
import { WorkSerialnumbersV2Service } from './services/work-serialnumbers-v-2.service';
import { WorkStatusesService } from './services/work-statuses.service';
import { WorkStatusV2Service } from './services/work-status-v-2.service';
import { WorkSuppliersV2Service } from './services/work-suppliers-v-2.service';
import { WorkTablesoccerV2Service } from './services/work-tablesoccer-v-2.service';
import { WorkTagsV2Service } from './services/work-tags-v-2.service';
import { WorkTaskgroupsV2Service } from './services/work-taskgroups-v-2.service';
import { WorkTasktypesV2Service } from './services/work-tasktypes-v-2.service';
import { WorkTeammembershipsV2Service } from './services/work-teammemberships-v-2.service';
import { WorkTeamsV2Service } from './services/work-teams-v-2.service';
import { WorkAppConfigV2Service } from './services/work-app-config-v-2.service';
import { WorkTimerecordsV2Service } from './services/work-timerecords-v-2.service';
import { WorkTimerecordtypesService } from './services/work-timerecordtypes.service';
import { WorkTimerecordtypesV2Service } from './services/work-timerecordtypes-v-2.service';
import { WorkTitlesV2Service } from './services/work-titles-v-2.service';
import { WorkTaskTabsV2Service } from './services/work-task-tabs-v-2.service';
import { WorkMyTodosV2Service } from './services/work-my-todos-v-2.service';
import { WorkTodosV2Service } from './services/work-todos-v-2.service';
import { WorkTrainingtypesV2Service } from './services/work-trainingtypes-v-2.service';
import { WorkUnitsV2Service } from './services/work-units-v-2.service';
import { WorkUploadsService } from './services/work-uploads.service';
import { WorkUserconfigurationsV2Service } from './services/work-userconfigurations-v-2.service';
import { WorkWebsiteArticlesAndBannersV2Service } from './services/work-website-articles-and-banners-v-2.service';
import { WorkWebsiteEmployeesV2Service } from './services/work-website-employees-v-2.service';
import { WorkWebsiteFormsV2Service } from './services/work-website-forms-v-2.service';
import { WorkWebsiteGoogleReviewsV2Service } from './services/work-website-google-reviews-v-2.service';
import { WorkWebsiteStatisticsV2Service } from './services/work-website-statistics-v-2.service';
import { WorkWorkflowsV2Service } from './services/work-workflows-v-2.service';
import { WorkWorkflowtasksV2Service } from './services/work-workflowtasks-v-2.service';
import { WorkWorkflowtasktypesV2Service } from './services/work-workflowtasktypes-v-2.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    WorkApiService,
    WorkEnvironmentService,
    WorkMailSenderV2Service,
    WorkAxovaNasSyncV2Service,
    WorkTenantsProjectLinksV2Service,
    WorkSelfserviceExternalProjectReferencesV2Service,
    WorkTenantsTaskLinksV2Service,
    WorkTenantsTaskChangelogsV2Service,
    WorkTenantsDocumentLinksService,
    WorkTenantsApiKeysV2Service,
    WorkTenantsV2Service,
    WorkTenantsToTenantsV2Service,
    WorkDocumentsService,
    WorkDocumentsV2Service,
    WorkElektroDrittkontrolleV2Service,
    WorkGerustbauV2Service,
    WorkMontageplanV2Service,
    WorkProjectsService,
    WorkProjectsV2Service,
    WorkAuthenticationService,
    WorkAuthenticationV2Service,
    WorkContactsService,
    WorkContactsV2Service,
    WorkContactsFinanceV2Service,
    WorkReservationsService,
    WorkReservationsV2Service,
    WorkGoogleCalendarApiService,
    WorkUsersService,
    WorkUsersV2Service,
    WorkUsersMeV2Service,
    WorkNotificationsV2Service,
    WorkPhonesV2Service,
    WorkTimerecordBalancesV2Service,
    WorkUseremploymentsV2Service,
    WorkSearchService,
    WorkSearchV2Service,
    WorkCalculationitemsGroupsV2Service,
    WorkCalculationitemsV2Service,
    WorkStandardtasksV2Service,
    WorkCalculationsV2Service,
    WorkCalculationTemplatesV2Service,
    WorkPricesV2Service,
    WorkPriceTiersV2Service,
    WorkBuildingservicesV2Service,
    WorkReportsV2Service,
    WorkAccountingV2Service,
    WorkProjectCostsV2Service,
    WorkConnectorsV2Service,
    WorkAbsencesService,
    WorkAbsencesV2Service,
    WorkTasksV2Service,
    WorkTaskChangeRequestsV2Service,
    WorkContactPersonsV2Service,
    WorkDocumentsGeneratorService,
    WorkDocumentsGeneratorV2Service,
    WorkDocumentsGeneratorV3Service,
    WorkHelpersService,
    WorkDebtorsV2Service,
    WorkDebtorsOverviewV2Service,
    WorkDebtorsCamtImportV2Service,
    WorkParashiftV2Service,
    WorkEquipmentsV2Service,
    WorkInteractionsV2Service,
    WorkTicketsV2Service,
    WorkTicketCategoriesV2Service,
    WorkLocationsService,
    WorkLocationsV2Service,
    WorkMailsV2Service,
    WorkItemsService,
    WorkItemsV2Service,
    WorkMessagingV2Service,
    WorkDocumenttypesV2Service,
    WorkProjectrevenuesService,
    WorkProjectrevenuesV2Service,
    WorkStandardtaskgroupsV2Service,
    WorkTimerecordHolidaysV2Service,
    WorkStocklocationsV2Service,
    WorkProjectCheckRulesV2Service,
    WorkProjectChecksV2Service,
    WorkProjectDurationOverrunV2Service,
    WorkDocumentTemplatesV2Service,
    WorkTimerecorddetailsService,
    WorkTimerecorddetailsV2Service,
    WorkTimeBlockTemplatesV2Service,
    WorkChatsV2Service,
    WorkOnetimepasswordsV2Service,
    WorkActivityTypesV2Service,
    WorkAddressService,
    WorkAdminMaintenanceService,
    WorkAdminDataQualityService,
    WorkAdminMontageplanService,
    WorkAdminDocumentIndexService,
    WorkAdminExternalProjectManagersService,
    WorkAgentsV2Service,
    WorkAppDevicesService,
    WorkAppDevicesV2Service,
    WorkPushNotificationTokensService,
    WorkPushNotificationTokensV2Service,
    WorkArchiveboxesV2Service,
    WorkAudiencesV2Service,
    WorkAuthenticatorsV2Service,
    WorkBudgetControllingV2Service,
    WorkBusinessdivisionsV2Service,
    WorkBusinessUnitsV2Service,
    WorkCategoriesService,
    WorkCategoriesV2Service,
    WorkCommentsService,
    WorkNewsService,
    WorkNewsV2Service,
    WorkContainersV2Service,
    WorkContainertypesV2Service,
    WorkDocumentsubtypesService,
    WorkDocumentsubtypesV2Service,
    WorkElectricalMeasurementsService,
    WorkElectricalmeasurementV2Service,
    WorkElectricalmeasurementtypesV2Service,
    WorkEquipmentintervalsV2Service,
    WorkEquipmentlogsV2Service,
    WorkEquipmentlogtypesV2Service,
    WorkEquipmenttypesV2Service,
    WorkEventInvitationsService,
    WorkEventInvitationsV2Service,
    WorkEventInvitationtypesService,
    WorkEventRegistrationOptionsService,
    WorkEventsService,
    WorkEventsV2Service,
    WorkEventTypesService,
    WorkFilesService,
    WorkLoggingService,
    WorkItemGroupsService,
    WorkItemCatalogsV2Service,
    WorkVouchersV2Service,
    WorkAiServicesV2Service,
    WorkCronjobRunsV2Service,
    WorkLeadCategoriesV2Service,
    WorkLeadSubCategoriesV2Service,
    WorkLoxoneV2Service,
    WorkMailtypesV2Service,
    WorkMeetingAgendaItemsV2Service,
    WorkMeetingDecisionsV2Service,
    WorkMeetingParticipantsV2Service,
    WorkMeetingsV2Service,
    WorkProspectsV2Service,
    WorkMeetingTypesV2Service,
    WorkMeetingTemplateAgendaItemsV2Service,
    WorkMeetingTemplateParticipantsV2Service,
    WorkMessagingTemplatesV2Service,
    WorkProjectdossierTemplatesV2Service,
    WorkProjectdossiersV2Service,
    WorkProjectSharesV2Service,
    WorkProjectSharesPublicV2Service,
    WorkMyService,
    WorkUsertrainingsV2Service,
    WorkOrdercartsV2Service,
    WorkOrdersV2Service,
    WorkOutcometypesV2Service,
    WorkPermissionsV2Service,
    WorkPersonnelFilesV2Service,
    WorkPersonnelFileCategoriesV2Service,
    WorkPhonetypesV2Service,
    WorkPowermembershipsV2Service,
    WorkProductgroupsV2Service,
    WorkRealEstateTypesV2Service,
    WorkReasontypesV2Service,
    WorkReferralsV2Service,
    WorkReservationteamsV2Service,
    WorkReservationtypesService,
    WorkReservationtypesV2Service,
    WorkRoletypesService,
    WorkRoletypesV2Service,
    WorkScreencomponentsV2Service,
    WorkScreendevicesV2Service,
    WorkScreenslidesV2Service,
    WorkSelfserviceGenericService,
    WorkSelfserviceItemsService,
    WorkSelfserviceProjectsService,
    WorkSelfserviceCalculationitemsService,
    WorkSelfserviceProjectHouseSidesService,
    WorkSelfserviceContactsService,
    WorkSelfserviceDocumentsService,
    WorkSelfserviceRevenueRebateService,
    WorkSelfserviceRealEstateTypesService,
    WorkSelfserviceTaskChangeRequestsService,
    WorkSelfserviceProjectChecksService,
    WorkSerialnumbersV2Service,
    WorkStatusesService,
    WorkStatusV2Service,
    WorkSuppliersV2Service,
    WorkTablesoccerV2Service,
    WorkTagsV2Service,
    WorkTaskgroupsV2Service,
    WorkTasktypesV2Service,
    WorkTeammembershipsV2Service,
    WorkTeamsV2Service,
    WorkAppConfigV2Service,
    WorkTimerecordsV2Service,
    WorkTimerecordtypesService,
    WorkTimerecordtypesV2Service,
    WorkTitlesV2Service,
    WorkTaskTabsV2Service,
    WorkMyTodosV2Service,
    WorkTodosV2Service,
    WorkTrainingtypesV2Service,
    WorkUnitsV2Service,
    WorkUploadsService,
    WorkUserconfigurationsV2Service,
    WorkWebsiteArticlesAndBannersV2Service,
    WorkWebsiteEmployeesV2Service,
    WorkWebsiteFormsV2Service,
    WorkWebsiteGoogleReviewsV2Service,
    WorkWebsiteStatisticsV2Service,
    WorkWorkflowsV2Service,
    WorkWorkflowtasksV2Service,
    WorkWorkflowtasktypesV2Service,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
